<style lang="stylus">
    .nalpromo
        position absolute
        left 0
        top 0
        width 100vw
        height 100vh
        pointer-events none
        z-index 100
        .nalpromo-center
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            box-shadow 0px 15px 30px 0px #00000026
            border-radius 8px
        .nalpromo-rb
            position absolute
            right 0
            bottom 0
        iframe
            border none
            outline none
            pointer-events auto
</style>

<template>
    <div class="nalpromo">
        <iframe
            ref="center"
            v-if="showCenter && nalPromoCenter.url"
            class="nalpromo-center"
            :style="{ width: `${nalPromoCenter.w}px`, height: `${nalPromoCenter.h}px` }"
            :src="nalPromoCenter.url + `&webtype=nalPromocenter${urlSuffix}`"
            frameborder="0"
        ></iframe>

        <iframe
            ref="rb"
            v-if="showRb && nalPromoRB.url"
            class="nalpromo-rb"
            :style="{ width: `${nalPromoRB.w}px`, height: `${nalPromoRB.h}px` }"
            :src="nalPromoRB.url + `&webtype=nalPromorb${urlSuffix}`"
            frameborder="0"
        ></iframe>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {},
    })
    export default class NalPromo extends Vue {
        @Prop()
        from;
        showCenter = false;
        showRb = false;
        get nalPromoCenter() {
            return this.$store.state.publicStore.nalPromo_center;
        }
        get nalPromoRB() {
            return this.$store.state.publicStore.nalPromo_rightbottom;
        }
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get urlSuffix() {
            return `&fromweb=1&lang=${this.lang}&user=${btoa(
                JSON.stringify({
                    id: this.userInfo.id,
                    token: this.userInfo.token,
                })
            )}`;
        }

        readLocal(type) {
            let limitNum = 0;
            if (type == "center") {
                if (this.nalPromoCenter.popups == 0) {
                    return true;
                }
                limitNum = this.nalPromoCenter.popups;
            } else {
                if (this.nalPromoRB.popups == 0) {
                    return true;
                }
                limitNum = this.nalPromoRB.popups;
            }
            let str = localStorage.getItem(`nalPromo_${this.from}`) || null;
            let pass = false;
            if (str) {
                let ai3Obj = JSON.parse(str);
                let list = ai3Obj[type] || [];
                let exit = false;
                for (let i = 0; i < list.length; i++) {
                    if (this.userInfo.id == list[i].user_id) {
                        exit = true;
                        pass = list[i].data < limitNum;
                        break;
                    }
                }
                !exit && (pass = true);
            } else {
                pass = true;
            }
            return pass;
        }
        saveLocal(type) {
            let str = localStorage.getItem(`nalPromo_${this.from}`) || null;
            let obj = null;
            if (str) {
                obj = JSON.parse(str);
                if (!obj.hasOwnProperty(type)) {
                    Object.assign(obj, { [type]: [] });
                }
                let list = obj[type];
                let exit = false;
                for (let item of list) {
                    if (item.user_id == this.userInfo.id) {
                        item.data++;
                        exit = true;
                        break;
                    }
                }
                if (!exit) {
                    list.push({
                        user_id: this.userInfo.id,
                        data: 1,
                    });
                }
            } else {
                obj = {
                    [type]: [
                        {
                            user_id: this.userInfo.id,
                            data: 1,
                        },
                    ],
                };
            }
            localStorage.setItem(`nalPromo_${this.from}`, JSON.stringify(obj));
        }

        checkShow() {
            if (this.nalPromoCenter.url && this.readLocal("center")) {
                setTimeout(() => {
                    this.showCenter = true;
                    this.saveLocal("center");
                    this.sensors.track("campaignPopupOpen");
                }, this.nalPromoCenter.wait * 1000);
            }
            if (this.nalPromoRB.url && this.readLocal("rb")) {
                setTimeout(() => {
                    this.showRb = true;
                    this.saveLocal("rb");
                }, this.nalPromoRB.wait * 1000);
            }
        }
        updateAD() {
            if (this.showCenter) {
                if (!this.nalPromoCenter.url) {
                    this.showCenter = false;
                }
            }
            if (this.showRb) {
                if (!this.nalPromoRB.url) {
                    this.showRb = false;
                }
            }
        }

        centerMessage(e) {
            const key = e.data.key ? e.data.key.split("_") : [],
                params = e.data.params;
            let prefix = key[0] || "";
            if (prefix == "nalPromocenter") {
                const str = key[1];
                if (str == "link") {
                    let newTab = window.open("about:blank");
                    newTab.location.href = params;
                } else if (str == "buypage") {
                    this.$openBuyPage("nalPromo_center");
                    this.showCenter = false;
                    this.sensors.track("campaignPopupClick", {
                        campaign_button: "get_click",
                    });
                } else if (str == "close") {
                    this.showCenter = false;
                    this.sensors.track("campaignPopupClick", {
                        campaign_button: "close_click",
                    });
                }
                this.$bus.$emit("delayAlert", 60);
            }
        }
        rbMessage(e) {
            const key = e.data.key ? e.data.key.split("_") : [],
                params = e.data.params;
            let prefix = key[0] || "";
            if (prefix == "nalPromorb") {
                const str = key[1];
                if (str == "link") {
                    let newTab = window.open("about:blank");
                    newTab.location.href = params;
                    this.aiPromo(this.nalPromoRB);
                } else if (str == "buypage") {
                    this.showRb = false;
                    this.$openBuyPage("nalPromo_rightbottom");
                } else if (str == "close") {
                    this.showRb = false;
                }
            }
        }
        aiPromo(obj) {
            // Edraw.ai的促销活动
            if (obj?.extra?.includes("EdrawAIsendToken")) {
                this.$edApi.putAiPromo({ user_id: this.userInfo.id, token: this.userInfo.token });
            }
        }
        created() {
            this.$bus.$on("update_ad", this.updateAD);
            if (this.nalPromoCenter.url && this.readLocal("center")) {
                this.$bus.$emit("delayAlert", -1);
            }
        }
        mounted() {
            window.addEventListener("message", this.centerMessage);
            window.addEventListener("message", this.rbMessage);
            this.checkShow();
        }
        beforeDestroy() {
            this.$bus.$off("update_ad", this.updateAD);
            window.removeEventListener("message", this.centerMessage);
            window.removeEventListener("message", this.rbMessage);
        }
    }
</script>
